<template>
  <tr v-for="linha in linhas" :key="linha" class="linha_carregando">
    <td v-for="coluna in colunas" :key="coluna">
      <span class="barra" :style="{ animationDelay: atraso(linha, coluna) }" />
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    linhas: {
      type: Number,
      default: 6,
    },
    colunas: {
      type: Number,
      default: 6,
    },
  },
  setup() {
    // Defasa o brilho de cada célula para o esqueleto não pulsar em bloco.
    function atraso(linha, coluna) {
      return ((linha + coluna) % 5) * 0.12 + "s";
    }

    return { atraso };
  },
};
</script>

<style scoped>
.linha_carregando td {
  padding: 14px 8px;
  vertical-align: middle;
}

.barra {
  background: #ededed;
  border-radius: 4px;
  display: block;
  height: 14px;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.barra::after {
  animation: brilho 1.4s ease-in-out infinite;
  animation-delay: inherit;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.85) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(-100%);
}

@keyframes brilho {
  100% {
    transform: translateX(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .barra::after {
    animation: none;
  }
}
</style>
